export const SET_TRANSACTIONS = '[APP] SET TRANSACTIONS';
export const SET_TRANSACTIONS_FILTER = '[APP] SET TRANSACTIONS FILTER';
export const SET_TRANSACTIONS_ERROR = '[APP] SET TRANSACTIONS ERROR';
export const CLEAR_TRANSACTIONS = '[APP] CLEAR TRANSACTIONS';
export const SET_TRANSACTIONS_TAB = '[APP] SET_TRANSACTIONS_TAB';
